import cButton from '#themes/default/default/components/button/button.js';
import cSvg from '#themes/default/default/components/svg/svg.js';
import cQrCode from '#themes/default/default/components/qrCode/qrCode.js';

import template from './payconiqModal.html' with { type: 'html' };

export default {
	name: 'CPayconiqModal',
	components: {
		cButton,
		cSvg,
		cQrCode
	},
	props: {
		order: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		retargetingUrl: {
			type: String,
			default: ''
		},
		selectedPayment: {
			type: Object,
			default: () => null
		},
		utils: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			remainingTime: '15:00',
			expiryCountdown: null,
			isQrCodeExpired: false
		};
	},
	computed: {
		headline() {
			return this.isQrCodeExpired ? this.t('payconiqModal_headlineExpired') : this.t('payconiqModal_headline');
		},
		payconiqExpiry() {
			return `${this.t('payconiqModal_expiry', {
				time: this.remainingTime
			})}`;
		}
	},
	mounted() {
		// Start the countdown
		this.timeCountdown();
	},
	destroyed() {
		clearInterval(this.expiryCountdown);
	},
	methods: {
		timeCountdown() {
			// 15 minutes in miliseconds
			const time = 15 * 60 * 1000;
			// Set the date X minutes from now
			const countdown = new Date(new Date().getTime() + time);
			// Update the count down every 1 second
			this.expiryCountdown = setInterval(() => {
				// Find the distance between now and the count down date
				const now = new Date().getTime();
				const distance = countdown - now;
				// Time calculations for remaining minutes and seconds
				const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
				const seconds = Math.floor(distance % (1000 * 60) / 1000);
				this.remainingTime = `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
				// If the count down is over, clear the timer
				if (distance < 0) {
					clearInterval(this.expiryCountdown);
					this.isQrCodeExpired = true;
				}
			}, 1000);
		},
		loadFreshCart() {
			this.$store.commit('SET_LOADER', true);
			location.href = this.retargetingUrl;
		}
	},
	template
};
